import { render, staticRenderFns } from "./SearchInstances.vue?vue&type=template&id=0496836c&lang=html"
import script from "./SearchInstances.vue?vue&type=script&lang=ts"
export * from "./SearchInstances.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports